module.exports = __webpack_public_path__ + "static/media/logoWhite.7979aaa0.svg";